import useJourneyLegIcons from "../../hooks/useJourneyLegIcons";
import { formatLegDepartureDate } from "../../utilities/date";

/**
 * Card list layout for QuoteHeader (layout 12)
 */
const QuoteHeaderJourneyLegCard = ({ legs, isSimple }) => {
    const { passengerIcon, luggageIcon } = useJourneyLegIcons({ isSimple, layout: 12 });

    const formattedLegs = legs.map((leg) => ({
        ...leg,
        formattedDepartureDate: formatLegDepartureDate(leg.departureDate),
    }));

    return (
        <div className="journey-leg journey-leg--12">
            <div className="journey-leg__card-list">
                {formattedLegs.map((leg, index) => (
                    <div key={index} className="journey-leg__card">
                        <div className="journey-leg__card-departure">
                            <div className="journey-leg__card-location">
                                <div className="journey-leg__long-form-location">{leg.fromLong}</div>
                                {leg.fromShort && (
                                    <div className="journey-leg__short-form-location">
                                        <span className="journey-leg__code-brackets">(</span>
                                        {leg.fromShort}
                                        <span className="journey-leg__code-brackets">)</span>
                                    </div>
                                )}
                            </div>
                            <div className="journey-leg__card-date-time">
                                {leg.formattedDepartureDate} {leg.departureTime}
                            </div>
                        </div>

                        <div className="journey-leg__card-connection">
                            <div className="journey-leg__card-dot"></div>
                            <div className="journey-leg__card-dotted-line"></div>
                            <div className="journey-leg__card-dot"></div>
                        </div>

                        <div className="journey-leg__card-arrival">
                            <div className="journey-leg__card-location">
                                <div className="journey-leg__long-form-location">{leg.toLong}</div>
                                {leg.toShort && (
                                    <div className="journey-leg__short-form-location">
                                        <span className="journey-leg__code-brackets">(</span>
                                        {leg.toShort}
                                        <span className="journey-leg__code-brackets">)</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="journey-leg__card-icons">
                            <div className="journey-leg__card-icon-item">
                                <img src={passengerIcon} alt="" className="journey-leg__card-icon" />
                                <span>{leg.passengers}</span>
                            </div>
                            <div className="journey-leg__card-icon-item">
                                <img src={luggageIcon} alt="" className="journey-leg__card-icon" />
                                <span>{leg.luggage}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuoteHeaderJourneyLegCard;
